import type React from "react";
import { CartIcon } from "~/icons";
import { Box } from "../Box/Box";
import { Text } from "../Text/Text";
import styles from "./CartLink.module.css";

export function CartLink(props: {
  cartItemQuantity: number;
  onGoToCheckout?: () => void;
}): React.ReactNode {
  // cap displayed count at 99, to avoid layout growing
  const count = props.cartItemQuantity > 99 ? 99 : props.cartItemQuantity;

  return (
    <Box
      background={count ? "primary" : "neutral-300"}
      className={styles.hoverable_opacity}
      onClick={props.onGoToCheckout}
      paddingX={"3"}
      display="flex"
      alignItems="center"
      style={{
        borderRadius: 50,
      }}
    >
      <Box display="flex" gap="2" alignItems="center">
        <Text color={count ? "overPrimary" : "jets-black"}>
          <CartIcon />
        </Text>
        <Text
          color={count ? "overPrimary" : "jets-black"}
          // Make font smaller when double digits, to avoid layout growing
          size={count > 9 ? "large" : "xxlarge"}
          font="special"
          weight="strong"
        >
          {count}
        </Text>
      </Box>
    </Box>
  );
}
